var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;var self = locals || {};const data = self.htmlWebpackPlugin.options.data
const language = data.locale
const revoWithLang = data.revoUrl + '?lang=' + language
pug_html = pug_html + "\u003Cdiv class=\"Revo\"\u003E\u003Ciframe id=\"revo-iframe\" src=\"https:\u002F\u002Fhost.drawbotics.com\u002Frevo\u002Fdemos\u002FLVZTOL\u002Fsales\u002F\" width=\"100%\" height=\"100%\" style=\"border:none;\"\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/pages/components/revo.pug
// module id = 107
// module chunks = 0